module.exports = __webpack_public_path__ + "static/media/HubFinder_10.38a5e802.webp";